var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/scenario/".concat(_vm.id)
    }
  }, [_c('div', {
    staticClass: "ml-auto"
  }), _vm.scenario.m_NamedType[1] >= 0 ? _c('v-list-item-avatar', {
    staticClass: "mr-2",
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('CharaIcon', {
    attrs: {
      "named": "",
      "id": _vm.scenario.m_NamedType[1],
      "size": _vm.$size()
    }
  })], 1) : _vm._e(), _vm.scenario.m_NamedType[0] >= 0 ? _c('v-list-item-avatar', {
    staticClass: "mr-2",
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('CharaIcon', {
    attrs: {
      "named": "",
      "id": _vm.scenario.m_NamedType[0],
      "size": _vm.$size()
    }
  })], 1) : _vm.scenario.m_CharaID >= 0 ? _c('v-list-item-avatar', {
    staticClass: "mr-2",
    attrs: {
      "size": _vm.$size()
    }
  }, [_c('CharaIcon', {
    attrs: {
      "id": _vm.scenario.m_CharaID,
      "size": _vm.$size()
    }
  })], 1) : _c('v-list-item-avatar', {
    staticClass: "mr-2",
    attrs: {
      "size": _vm.$size(32),
      "color": "primary"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.scenario.m_ScriptTextName,
      expression: "scenario.m_ScriptTextName"
    }],
    staticClass: "white--text"
  }, [_vm._v(_vm._s(parseInt(_vm.scenario.m_ScriptTextName.slice(-2))))])]), _c('div', {
    staticClass: "mr-md-2"
  }), _c('v-list-item-content', {
    staticClass: "ml-0",
    style: {
      'max-width': _vm.scenario.m_NamedType[1] >= 0 ? 384 - _vm.$size() - 8 + 'px' : '384px'
    }
  }, [_vm.scenario.m_NamedType[1] >= 0 ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Cross Scenario')))]) : _vm.scenario.m_NamedType[0] >= 0 ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Character Scenario')))]) : _vm.scenario.m_CharaID >= 0 ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Memorial Scenario')))]) : _vm._e(), _c('v-list-item-title', [_vm._v(_vm._s(_vm.scenario.m_Title))])], 1), _c('div', {
    staticClass: "mr-auto"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }